// extracted by mini-css-extract-plugin
export var aside__illustration = "index-module--aside__illustration--13tBF";
export var aside__title = "index-module--aside__title--3fq8U";
export var aside__social__button = "index-module--aside__social__button--3EXxf";
export var postSection = "index-module--postSection--2TAaJ";
export var post = "index-module--post--35ElZ";